import { type TFetchableData, type TFetchableItems } from '../types';

const wrapDependenciesItems = (dependencies: TFetchableData): TFetchableItems =>
  Object.fromEntries(Object.entries(dependencies).map(([key, data]) => [key, { data }])) as TFetchableItems;

export default wrapDependenciesItems;
